var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.728,
    height: 67.481,
    viewBox: "0 0 78.728 67.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-school",
    "data-name": "Icon ionic-md-school",
    className: "cls-1",
    d: "M16.572,42.669v14.99L41.614,71.981,66.655,57.659V42.669L41.614,56.991ZM41.614,4.5,2.25,26.994,41.614,49.487l32.212-18.4v25.9h7.152v-30Z",
    transform: "translate(-2.25 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegree);
export default __webpack_public_path__ + "static/media/degree.9a560b68846ada5ba5dda85253e4fb12.svg";
export { ForwardRef as ReactComponent };